import React, { useMemo } from 'react';
import { useStravaExperiment } from '@strava/container-context';
import StravaLogo from '@strava/ui/StravaLogo';
import Button from '@strava/ui/Button';
import { useSignUpModalContext } from '@strava/authentication-ui';
import { useFrontDoorsPageContainerContext } from '../../../../state/FrontDoorsPageContainerContext';
import styles from './DesktopNav.module.scss';
import IconButton from '../../../IconButton';
import { isNavSignUpVariantA } from '../../../../shared/pageUtils';

const DesktopNav = () => {
  const {
    t,
    state,
    track,
    onDesktopHeaderLoginBtnClick,
    onDesktopHeaderSignupBtnClick,
    onDesktopHeaderLogoClick
  } = useFrontDoorsPageContainerContext();
  const { openSignUpModal } = useSignUpModalContext();
  const { experiment } = useStravaExperiment();
  const { menuConfig } = state;
  const { showLoginOptionOnly } = menuConfig;

  const handleLoginBtnClick = () => {
    onDesktopHeaderLoginBtnClick();
    window.location.href = '/login';
  };

  const handleSignupBtnClick = () => {
    onDesktopHeaderSignupBtnClick();
    /**
     * [ACQN-1233] Add Signup Modal to Top Nav
     * TODO: delete this code once the experiment is over
     * https://strava.atlassian.net/wiki/spaces/TG/pages/2350186497/WIP+Add+Sign+up+Modal+to+Top+Nav
     */
    if (isNavSignUpVariantA(experiment)) {
      openSignUpModal('generic');
    } else {
      // control and fallback
      window.location.href = '/register';
    }
  };

  const handleLogoClick = () => {
    onDesktopHeaderLogoClick();
    window.location.href = '/';
  };

  const navLinks = useMemo(
    () => [
      {
        key: 'features',
        name: t('header.menu.features'),
        href: '/features'
      },
      {
        key: 'challenges',
        name: t('header.menu.challenges'),
        href: '/challenges'
      },
      {
        key: 'subscription',
        name: t('header.menu.subscription'),
        href: '/subscribe?origin=website_header'
      }
    ],
    [t]
  );

  const trackNavLink = (element) => {
    track({ action: 'click', element });
  };

  return (
    <div className={styles.container}>
      <div className={styles.logoAndLinks}>
        <IconButton onClick={handleLogoClick} ariaLabel="Strava">
          <StravaLogo
            id="fdpc-desktop-nav-strava-logo"
            width={95}
            height={20}
            alt=""
          />
        </IconButton>
        <ul className={styles.navLinks}>
          {navLinks.map(({ key, name, href }) => (
            <li key={key}>
              <a href={href} onClick={() => trackNavLink(key)}>
                {name}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <Button
          className={styles.loginBtn}
          type="button"
          onClick={handleLoginBtnClick}
          data-cy="login_btn"
          variant="default"
        >
          {t('header.log_in')}
        </Button>
        {!showLoginOptionOnly && (
          <Button
            className={styles.signupBtn}
            type="button"
            onClick={handleSignupBtnClick}
            data-cy="signup_btn"
            variant="primary"
          >
            {t(`header.join_us`)}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DesktopNav;
